<div class="flex flex-row justify-center items-center footer mat-subtitle-2 mb-0 fs-12 fw-400">
  <img class="logo mr-36" src="assets/images/temenos-logo.png" alt="Logo">
  <div>{{ 'FOOTER.COPYRIGHT' | transloco : {year: year} }}</div>
  <div class="copyright delimiter"></div>
  <a href="{{Constants.PRIVACY_POLICY_URL}}" target="_blank">{{ 'FOOTER.PRIVACY_POLICY' | transloco }}</a>
  <div class="copyright delimiter"></div>
  <a href="{{Constants.TERMS_AND_CONDITIONS_URL}}" target="_blank">{{ 'FOOTER.TERMS_AND_CONDITIONS' | transloco }}</a>
</div>
